import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { DatetimeField } from '~admin/view/components/ui/form/fields/field-datetime.component';
import { Box } from '~common/components/box.component';
import { Column } from '~common/components/column.component';

export interface DiscoverDatetimeFormData {
  discoverDateStart: string;
  discoverDateEnd: string;
}

export const DiscoverDatetime: React.FunctionComponent = () => {
  const { t } = useTranslation();

  return (
    <Container>
      <Row>
        <RestrictBox>
          <DatetimeField
            name={'discoverDateStart'}
            label={t('createEvent.eventDetails.dateTime.discover.startDate')}
          />
        </RestrictBox>
        <RestrictBox>
          <DatetimeField
            name={'discoverDateEnd'}
            label={t('createEvent.eventDetails.dateTime.discover.endDate')}
          />
        </RestrictBox>
      </Row>
    </Container>
  );
};

const Container = styled(Column)`
  flex: 1 1 auto;
`;

const Row = styled(Box)`
  margin-top: 12px;
  > div:not(:first-child) {
    margin-left: 50px;
  }
`;

const RestrictBox = styled(Box)`
  flex: 1 1 auto;
`;



// WEBPACK FOOTER //
// ./view/components/details/event-details/event-datetime-details/discover-datetime.component.tsx